import { render } from "./PayImageGalleryShell.vue?vue&type=template&id=1405337b&scoped=true"
import script from "./PayImageGalleryShell.vue?vue&type=script&lang=js"
export * from "./PayImageGalleryShell.vue?vue&type=script&lang=js"

import "./PayImageGalleryShell.vue?vue&type=style&index=0&id=1405337b&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1405337b"]])

export default __exports__